module.exports = {
	"No notifications found.": "Nessuna notifica trovata.",
	"Notifications": "Notifiche",
	"See all notifications": "Vedi tutte le notifiche",
	"Mark all as read": "Segnala tutte come già lette."
};


//////////////////
// WEBPACK FOOTER
// ./~/@99designs/globalnav/translations/it.json
// module id = 903
// module chunks = 33